import Store from "store/store";

export default class Filter {

    static Sort = {
        ASC: "asc",
        DESC: "desc"
    };

    constructor(data) {
        this.name = null;
        this.first = 0;
        this.max = 25;
        this.sortBy = null;
        this.sortType = Filter.Sort.ASC;

        if (data) {
            Object.assign(this, data);
        }
    }

    static load = function (name, type) {
        var filter = Store.get(name);
        filter = new type(filter);
        return filter;
    };

    save(name) {
        name = name || this.name;

        if (!name) {
            throw "Now filter name defined";
        }

        Store.set('filter.vehicles', this);
    }

    reset() {
        this.first = 0;
        this.max = 25;
        this.sortBy = null;
        this.sortType = Filter.Sort.ASC;
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/model/filter.model.js